import React from 'react';

import { BiBot } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';
import How2Install from 'components/explore/How2Install';

import JobAddButton from './JobAddButton';

const NoJobRecords = ({ botId }) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex flex-column p-5 align-items-center justify-content-center">
      <BiBot size={100} color="#ccc" />
      <p className="mt-3">{t('keys.no_entries')}</p>
      <p>
        <JobAddButton botId={botId} className="btn btn-primary btn-lg" />
      </p>

      <div className="col-md-6 mt-5">
        <div className="card">
          <div className="card-body">
            <How2Install />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoJobRecords;
